"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultInstanceSettings = void 0;
exports.defaultInstanceSettings = {
    nav: {
        autoStep: false,
        splitModuleComponents: false,
        pageSize: 4,
    },
    thanks: {
        moreInfo: false,
        href: false,
        showPoweredBySmile: true,
        showLogo: true,
        imageHeight: '100px',
        titleSize: '24px',
        subtitleSize: '24px',
        text: '',
    },
    form: {
        marginBottomTitle: '10px',
        marginTopTitle: '10px',
        marginBottomSubtitle: '20px',
        marginTopFooter: '5px',
        marginBottomFooter: '5px',
        fields: [],
    },
    ui: {
        theme: {
            templates: [],
            lightPalette: {
                '--arrow-background-color': '#ffffff',
                '--arrow-icon-color': '#000000',
                '--background-color': '#ffffff',
                '--button-send-background-color': '#6164f6',
                '--button-send-font-color': '#ffffff',
                '--progressBar-color': '#6164f6',
                '--question-color': '#000000',
                '--response-color': '#000000',
                '--response-selected-color': '#6164f6',
            },
            darkPalette: {
                '--arrow-background-color': '#ffffff',
                '--arrow-icon-color': '#000000',
                '--background-color': '#ffffff',
                '--button-send-background-color': '#6164f6',
                '--button-send-font-color': '#ffffff',
                '--progressBar-color': '#6164f6',
                '--question-color': '#000000',
                '--response-color': '#000000',
                '--response-selected-color': '#6164f6',
            },
            defaultPalette: 'light',
            buttonType: 'default',
            smilesCsat: undefined,
            smiles: undefined,
            scores: undefined,
        }
    },
};
